

<div class="loading" *ngIf="global.loading">Loading&#8230;</div>

<router-outlet></router-outlet>



